import differenceInDays from 'date-fns/differenceInDays'

// Wagner Smart Logger V2 memory: "Storage Capacity: 16,384 readings" — each interval capture
// (temperature + relative humidity together) is one stored entry.
export const DATA_LOGGER_MEMORY_CAPACITY = 16384

// Days of logging the on-board memory holds at a given measurement interval:
// capacity(entries) * interval(hours) / 24(hours per day)
export const getMemoryCapacityDays = (intervalInHours: number): number => (DATA_LOGGER_MEMORY_CAPACITY * intervalInHours) / 24

// Whole days elapsed since the device was activated (createdAt). `now` is injectable for tests.
export const getDaysSinceActivation = (createdAt: string, now: Date = new Date()): number => differenceInDays(now, new Date(createdAt))

export type HealthSeverity = 'warning' | 'danger'

// Highlight as the device approaches its memory-full date:
// yellow within 60 days of capacity, red within 30 (red takes precedence).
export const classifyDaysSinceActivation = (days: number, capacityDays: number | null): HealthSeverity | null => {
  if (!capacityDays || !Number.isFinite(capacityDays)) return null
  if (days > capacityDays - 30) return 'danger'
  if (days > capacityDays - 60) return 'warning'
  return null
}

// Battery level is a 0-100 percentage: yellow below 30%, red below 15% (red takes precedence).
export const classifyBatteryLevel = (battery: number | null | undefined): HealthSeverity | null => {
  if (battery === null || battery === undefined || !Number.isFinite(battery)) return null
  if (battery < 15) return 'danger'
  if (battery < 30) return 'warning'
  return null
}

export const healthCellPalette: Record<HealthSeverity, { background: string; text: string }> = {
  warning: { background: '#fff9c4', text: '#f57f17' },
  danger: { background: '#ef9a9a', text: '#b71c1c' }
}
